import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {fetchBalance} from "../user/UserActions";
import {ContentModelName} from "../contenful/types";
import {fetchContent} from "../contenful/ContentfulActions";
import {CurrencyDefinition} from "../http/protocol";
import {fetchSettings} from "../settings/SettingsActions";
import {showCashier} from "../payments/DepositActions";
import {withRouter} from "react-router";
import {RouteComponentProps} from "react-router-dom";

import React from "react";
import {getContainer} from "../ioc/IOCSetup";
import Loader from "../layout/Loader";
import {getOnrampCurrency} from "../selectors/payments-selectors";
import {t} from "../i18n";

class BuyCrypto extends React.Component<AllProps, { currency? : CurrencyDefinition, url? : string, external ? : boolean}> {

    constructor(props : AllProps) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }
    init() {
        if(this.props.currency && this.props.currency.code) {
            getContainer().getPaymentsService().launcOnramp(this.props.currency.code).then(r => {
                this.setState({ url : r.url, external : r.openInNewWindow});
            })

        }
    }
    componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<{ currency?: CurrencyDefinition; url?: string }>, snapshot?: any) {
        if(this.props.currency != prevProps.currency) {
            this.init();
        }
    }

    render() {
        return (
            <div className="cashier-inner-container buy-crypto content-wrapper">
                {!this.state.url &&  <div className={"buy-crypto-loading"}> <Loader /></div>}
                {!this.state.external && this.state.url && <iframe className={"buy-crypto-iframe " + (this.props.mobile ? "mobile" : "")} frameBorder={0} src={this.state.url} />}
                {this.state.external && this.state.url && (
                    <div className={"open-in-new-tab"}>
                      <div>
                          <div className={"buy-crypto-description"}>
                            <h3 className={"title"}>{t("onramper.title")}</h3>
                              {t("onramper.description")}
                          </div>
                          <a className={"btn btn-cta full-width"} onClick={()=> window.open(this.state.url, "_blank")}>{t("onramper.open-in-new-window")}</a>
                          <div className={"disclaimer"}>
                              <span className={"disclaimer-title"}>
                               {t("onramper.disclaimer-title")}
                              </span> {t("onramper.disclaimer-description")}
                          </div>
                      </div>
                    </div>
                )}
            </div>
        )
    }
}

interface OtherProps extends RouteComponentProps {
}
type AllProps = PropsFromDispatch & PropsFromState & OtherProps;
interface PropsFromState {
   currency? : CurrencyDefinition;
   mobile? : boolean;
}

interface PropsFromDispatch {

}
const mapStateToProps = (state : AppState) : PropsFromState =>  {
    return {
       currency : getOnrampCurrency(state),
       mobile : state.settings.mobile
    }
};
const mapDispatchToProps = (dispatch : Dispatch) : PropsFromDispatch => (
    {
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        fetchSettings: () => dispatch(fetchSettings() as any),
        hide : () => dispatch(showCashier(false)),
        fetchBalance : ()=>dispatch(fetchBalance() as any)
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter<AllProps,any>(BuyCrypto));
